import axios from "axios";
import Vue from "vue";
import store from "../store";
import qs from "querystring";

//响应拦截器即异常处理
axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error && error.response) {
      switch (error.response.code) {
        case 404:
          error.message = "请求错误,未找到该资源";
          break;
        case 500:
          error.message = "服务器端出错";
          break;
        default:
          error.message = `连接错误${error.response.statusText}`;
      }
    } else {
      error.message = "连接到服务器失败";
    }
    return Promise.resolve({
        data: {
          data: error.reponse.data,
          code: error.reponse.status + ""
        },
    });
    // return Promise.resolve(error.response);
  }
);

// axios.defaults.headers = {
//   "Content-Type": "application/x-www-form-urlencoded" //  //
// };
console.log(axios.defaults,'d')
axios.defaults.timeout = 180000;

//get请求
export function get(url, param) {
  return new Promise((resolve, reject) => {
    axios({
      method: "get",
      url,
      params: param,
      headers:{
        "Content-Type": "application/x-www-form-urlencoded"
      }
    }).then(res => {
      resolve(res.data);
    });
  });
}

//post请求
export function post(url, param) {
  return new Promise((resolve, reject) => {
    //发送请求之前显示loading
    store.commit("SET_LOADING", true);
    axios({
      method: "post",
      url,
      data: qs.stringify(param),
      headers:{
        "Content-Type": "application/x-www-form-urlencoded"
      }
    }).then(res => {
      resolve(res.data);
      //获取到数据后关闭数据加载效果
      Vue.nextTick(function() {
        store.commit("SET_LOADING", false);
      });
    });
  });
}

//post请求
export function upload(url, param) {
  return new Promise((resolve, reject) => {
    //发送请求之前显示loading
    store.commit("SET_LOADING", true);
    axios({
      method: "post",
      url,
      data: param,
      headers:{
        "Content-Type": "multipart/form-data"
      }
    }).then(res => {
      resolve(res.data);
      //获取到数据后关闭数据加载效果
      Vue.nextTick(function() {
        store.commit("SET_LOADING", false);
      });
    });
  });
}






// WEBPACK FOOTER //
// ./src/api/index.js